(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-lifestyle-journal"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('rl-journal'))customElements.define('rl-journal',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.rail=this.querySelector('[data-journal-rail]');this.cards=[...this.querySelectorAll('[data-journal-card]')];this.prev=this.querySelector('[data-journal-prev]');this.next=this.querySelector('[data-journal-next]');this.pause=this.querySelector('[data-journal-pause]');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches;this.autoplay=this.dataset.autoplay==='true';this.seconds=Math.max(8,Number(this.dataset.interval)/1000||10);this.lastTime=0;
  if(this.autoplay){this.classList.add('rl-journal--flow');this.cards.forEach(card=>{const copy=card.cloneNode(true);copy.classList.add('rl-journal__clone');copy.removeAttribute('data-journal-card');copy.removeAttribute('data-block-id');copy.removeAttribute('data-shopify-editor-block');copy.setAttribute('aria-hidden','true');copy.inert=true;copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));copy.querySelectorAll('img').forEach(img=>img.alt='');this.rail.append(copy)})}
  this.measure=()=>{if(!this.cards.length){this.cycle=0;this.update();return}this.step=this.cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.rail).columnGap)||0);this.cycle=this.step*this.cards.length;this.loop=this.autoplay&&this.cycle>this.rail.clientWidth;this.update();this.sync()};
  this.update=()=>{this.prev.disabled=!this.loop&&this.rail.scrollLeft<3;this.next.disabled=!this.loop&&this.rail.scrollLeft>=this.rail.scrollWidth-this.rail.clientWidth-3};
  this.tick=time=>{this.frame=0;if(!this.canRun())return;const dt=this.lastTime?Math.min(50,time-this.lastTime):0;this.lastTime=time;let x=this.position+this.step*dt/(this.seconds*1000);if(x>=this.cycle)x-=this.cycle;this.position=x;this.rail.scrollLeft=x;this.frame=requestAnimationFrame(this.tick)};
  this.canRun=()=>this.loop&&!this.userPaused;
  this.sync=()=>{if(this.canRun()){if(!this.frame){this.lastTime=0;this.position=this.rail.scrollLeft;this.frame=requestAnimationFrame(this.tick)}}else{cancelAnimationFrame(this.frame);this.frame=0;this.lastTime=0}};
  this.label=()=>{if(this.pause){this.pause.textContent=this.userPaused?this.pause.dataset.playLabel:this.pause.dataset.pauseLabel;this.pause.setAttribute('aria-pressed',String(this.userPaused))}};
  this.move=direction=>{let target=this.rail.scrollLeft+direction*(this.step||300);const wraps=this.loop&&(target<0||target>=this.cycle);if(this.loop)target=(target%this.cycle+this.cycle)%this.cycle;this.position=target;this.rail.scrollTo({left:target,behavior:this.autoplay||this.motion.matches||wraps?'instant':'smooth'})};
  this.prev.addEventListener('click',()=>this.move(-1),{signal});this.next.addEventListener('click',()=>this.move(1),{signal});
  this.rail.addEventListener('scroll',()=>{if(!this.scrollFrame)this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=0;if(this.loop&&this.rail.scrollLeft>=this.cycle)this.rail.scrollLeft-=this.cycle;if(Math.abs(this.rail.scrollLeft-this.position)>2)this.position=this.rail.scrollLeft;this.update()})},{signal,passive:true});
  this.rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1)}},{signal});
  this.pause?.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.label();this.sync()},{signal});
  this.addEventListener('shopify:block:select',e=>{const index=this.cards.findIndex(c=>c.dataset.blockId===e.detail.blockId);if(index>=0){this.rail.scrollTo({left:index*this.step,behavior:'instant'})}},{signal});
  document.addEventListener('visibilitychange',this.sync,{signal});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.userPaused=true;this.label();this.sync()},{signal});
  this.resizeObserver=new ResizeObserver(this.measure);this.resizeObserver.observe(this.rail);this.measure();this.label();
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);this.resizeObserver?.disconnect();this.querySelectorAll('.rl-journal__clone').forEach(c=>c.remove());this.frame=0;this.scrollFrame=0}
});

  } catch(e) { console.error(e); }
})();
})();
